import { render, staticRenderFns } from "./CLoadingBox.vue?vue&type=template&id=4e794703&scoped=true"
import script from "./CLoadingBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CLoadingBox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CLoadingBox.vue?vue&type=style&index=0&id=4e794703&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e794703",
  null
  
)

export default component.exports